/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventFloorInfo,
    JsonEventFloorInfoFromJSON,
    JsonEventFloorInfoFromJSONTyped,
    JsonEventFloorInfoToJSON,
} from './JsonEventFloorInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonEventFloorInfo
 */
export interface ApiResultOfListOfJsonEventFloorInfo {
    /**
     * 
     * @type {Array<JsonEventFloorInfo>}
     * @memberof ApiResultOfListOfJsonEventFloorInfo
     */
    data?: Array<JsonEventFloorInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventFloorInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonEventFloorInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventFloorInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventFloorInfo
     */
    result?: ApiResultOfListOfJsonEventFloorInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonEventFloorInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonEventFloorInfoFromJSON(json: any): ApiResultOfListOfJsonEventFloorInfo {
    return ApiResultOfListOfJsonEventFloorInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonEventFloorInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonEventFloorInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonEventFloorInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonEventFloorInfoToJSON(value?: ApiResultOfListOfJsonEventFloorInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonEventFloorInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

